<template>
  <div
    id="revisionModal"
    class="modal fade"
    data-backdrop="static"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Confirme abaixo as inconsistências a serem enviadas para revisão
          </h5>
        </div>
        <div class="modal-body">
          <ol>
            <li v-for="field in fields" :key="field">{{ field.campo }}</li>
            <li v-for="file in files" :key="file">{{ file.documento }}</li>
          </ol>
          <textarea
            id=""
            v-model="$parent.data.observacao"
            cols="30"
            name=""
            placeholder="Digite aqui alguma observação se for necessário"
            rows="5"
            maxlength="750"
            @keyup="countCharacters"
          ></textarea>
          <p style="text-align: right; margin-bottom: 0">
            {{ characters }} caracteres restantes
          </p>
        </div>
        <div class="modal-footer">
          <button
            aria-label="Close"
            class="btn-cancel"
            data-bs-dismiss="modal"
            type="button"
          >
            Cancelar
          </button>
          <button
            aria-label="Close"
            data-bs-dismiss="modal"
            type="button"
            @click="sendValidation"
          >
            Confirmar envio
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RevisionModal",

  props: {
    fields: {
      type: Object,
      required: true,
    },
    files: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      reviewSentModal: null,
      characters: 750,
    };
  },

  methods: {
    sendValidation() {
      this.$parent.sendValidation();
    },

    countCharacters() {
      const limit = 750;
      const string = this.$parent.data.observacao;
      this.characters = limit - string.length;
    }
  },
};
</script>

<style scoped>
textarea {
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #282828;
  border-radius: 10px;
  font-size: 18px;
  resize: none;
  text-align: center;
}

textarea:focus {
  border-color: #282828;
}

/* ESTILIZAÇÃO DA LISTA */

ol {
  margin: 0;
  padding: 0;
  padding-left: 20px;
  padding-bottom: 1rem;
}

li {
  list-style-type: disc;
  font-size: 18px;
}

/* ESTILIZAÇÃO DO MODAL */
.modal-content {
  border-radius: 10px;
  padding: 2rem;
}

.modal-header {
  border-bottom: none;
}

.modal-header,
.modal-body,
.modal-footer {
  padding: 0;
}

.modal-body {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.modal-footer {
  border-top: none;
  justify-content: space-between;
}

button {
  width: 45%;
  padding: 1em;
  height: 60px;
  border-radius: 10px;
  border: none;
  color: white;
  background-color: #004a8a;
  font-weight: bold;
  cursor: pointer;
  font-size: 18px;
}

button:hover,
button.btn-cancel:hover {
  background-color: #5aad31;
}

button.btn-cancel {
  background-color: #828282;
}

h5 {
  color: #004a8a;
  font-size: 24px;
}

@media (max-width: 576px) {
  button {
    width: 100%;
  }

  .modal-footer {
    flex-direction: column-reverse;
  }
}
</style>
